module.exports = __webpack_public_path__ + "img/index.f47a7beb.png";